export const PULSELEADS_LEADS_NOT_DISTRIBUTED_TITLE = "title.pulseleads.not.distributed";

export const PULSELEADS_LEADS_NOT_DISTRIBUTED_NAMESPACE = "PULSELEADS-LEADS-NOT-DISTRIBUTED";

export const PULSELEADS_LEADS_PATH = "/leads";
export const PULSELEADS_LEADS_NOT_DISTRIBUTED_PATH = "/assign";
